export const getAllOrganizationsQueryKey = () => ["organizations"];

export const getOrganizationQueryKey = (
	organizationId: string | null | undefined,
	includeLegal?: boolean,
	includeRoles?: boolean,
) => ["organizations", organizationId, { includeLegal, includeRoles }];
